import React, { MouseEvent } from "react"
import { SuiteCardChooseButton } from "@silversea-ssc/ui-components-react"
import { Trans } from "@lingui/macro"

type Props = { selected: boolean; onSelect: (e: MouseEvent) => void }
export const ChooseButton: React.FC<Props> = ({ selected, onSelect }) => (
    <SuiteCardChooseButton
        selected={selected}
        variant="primary"
        onClick={onSelect}
        className="cy-choose-suite-category-btn"
        dataContentPiece="choose-suite-category"
    >
        {selected ? <Trans>Choosen</Trans> : <Trans>Choose</Trans>}
    </SuiteCardChooseButton>
)
